export { default } from './ProtectedRoutes';
